export function headerFunc() {

  /**
    * ハンバーガーメニュー
    */
  $('.js-hamburger').on('click', function() {
    if($('.l-hamburger__line').hasClass('is-open')) {
      $('.l-hamburger__line').removeClass('is-open');
      $('.l-drawer').removeClass('is-open');
      bodyFixedOff();
    } else {
      $('.l-hamburger__line').addClass('is-open');
      $('.l-drawer').addClass('is-open');
      bodyFixedOn();
    }

    return false;
  });

  // クリックしたらメニュー閉じる
  $('.l-drawer__item a').on('click', function() {
    if($('.l-hamburger__line').hasClass('is-open')) {
      $('.l-hamburger__line').removeClass('is-open');
      $('.l-drawer').removeClass('is-open');
      bodyFixedOff();
    }

    return false;
  });


}
